<template>
  <v-card class="outlined-card pa-5 d-flex flex-column" elevation="0">
    <div class="d-flex justify-space-between align-center mb-4 flex-shrink-0">
      <h3 class="text-subtitle-1 font-weight-bold text-uppercase" style="color: #424242">Điểm danh</h3>
      <router-link :to="{ name: 'attendances' }" class="text-body-2 blue--text font-weight-medium text-decoration-none"
        >Xem chi tiết</router-link
      >
    </div>
    <div class="attendance-container flex-grow-1">
      <div class="chart-section">
        <div class="chart-wrapper">
          <svg viewBox="0 0 100 100" class="chart-svg chart-svg-rotated">
            <circle
              v-for="(seg, i) in donutSegments"
              :key="i"
              cx="50"
              cy="50"
              r="40"
              fill="none"
              :stroke="seg.color"
              stroke-width="12"
              stroke-linecap="round"
              :stroke-dasharray="seg.dasharray"
              :stroke-dashoffset="seg.dashoffset"
              pathLength="100"
            />
          </svg>
          <div class="chart-center-content">
            <div v-if="loading" class="chart-value">
              <v-progress-circular indeterminate size="24" color="primary"></v-progress-circular>
            </div>
            <div v-else class="chart-value">{{ presentPercentage }}%</div>
            <div class="chart-label">HS có mặt</div>
          </div>
        </div>
      </div>
      <div class="legend-section">
        <div class="legend-grid">
          <div class="legend-item">
            <div class="legend-dot" style="background-color: #0e66ff"></div>
            <div class="legend-val" style="color: #0e66ff">
              <v-progress-circular v-if="loading" indeterminate size="16" color="#0E66FF"></v-progress-circular>
              <span v-else>{{ formatNumber(displayStats.present) }}</span>
            </div>
            <div class="legend-text">Đang có mặt</div>
          </div>
          <div class="legend-item">
            <div class="legend-dot" style="background-color: #fb8c00"></div>
            <div class="legend-val" style="color: #fb8c00">
              <v-progress-circular v-if="loading" indeterminate size="16" color="#FB8C00"></v-progress-circular>
              <span v-else>{{ formatNumber(displayStats.absent) }}</span>
            </div>
            <div class="legend-text">Vắng mặt</div>
          </div>
          <div class="legend-item">
            <div class="legend-dot" style="background-color: #ffcdd2"></div>
            <div class="legend-val" style="color: #ef5350">
              <v-progress-circular v-if="loading" indeterminate size="16" color="#EF5350"></v-progress-circular>
              <span v-else>{{ formatNumber(displayStats.notCheckin) }}</span>
            </div>
            <div class="legend-text">Chưa điểm danh</div>
          </div>
          <div class="legend-item">
            <div class="legend-dot" style="background-color: #e8f5e9"></div>
            <div class="legend-val" style="color: #4caf50">
              <v-progress-circular v-if="loading" indeterminate size="16" color="#4CAF50"></v-progress-circular>
              <span v-else>{{ formatNumber(displayStats.left) }}</span>
            </div>
            <div class="legend-text">Đã ra về</div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { Attendance } from '@/plugins/api'

export default {
  name: 'DashboardAttendanceToday',
  data() {
    return {
      stats: null,
      loading: true,
    }
  },
  computed: {
    displayStats() {
      if (!this.stats) {
        return { present: 0, absent: 0, notCheckin: 0, left: 0 }
      }
      return {
        present: this.stats.totalPresent || 0,
        absent: this.stats.totalAbsent || 0,
        notCheckin: this.stats.totalNotCheckin || 0,
        left: this.stats.totalLeft || 0,
      }
    },
    donutSegments() {
      const { present, absent, notCheckin, left } = this.displayStats

      const total = present + absent + notCheckin + left
      if (total === 0) {
        return [{ color: '#E0E0E0', dasharray: '100 100', dashoffset: 0, length: 100 }]
      }

      const data = [
        { value: present, color: '#0E66FF' },
        { value: absent, color: '#FB8C00' },
        { value: notCheckin, color: '#FFCDD2' },
        { value: left, color: '#E8F5E9' },
      ].filter(item => item.value > 0)

      const mathGap = data.length > 1 ? 8 : 0
      let totalAssigned = 0

      const segments = data.map(item => {
        let len = item.value
        totalAssigned += len + mathGap
        return { ...item, length: len }
      })

      const scale = 100 / (totalAssigned || 1)

      let currentOffset = 0
      return segments.map(seg => {
        const finalLength = seg.length * scale
        const finalGap = mathGap * scale
        const offset = currentOffset
        currentOffset += finalLength + finalGap

        return {
          color: seg.color,
          dasharray: `${finalLength} 100`,
          dashoffset: -offset,
        }
      })
    },
    presentPercentage() {
      const { present, absent, notCheckin, left } = this.displayStats
      const total = present + absent + notCheckin + left
      if (!total) return 0
      return Math.round((present / total) * 100)
    },
  },
  created() {
    this.fetchStats()
  },
  methods: {
    formatNumber(num) {
      if (num == null) return '0'
      return Number(num).toLocaleString('de-DE')
    },
    async fetchStats() {
      this.loading = true
      try {
        const response = await Attendance.getDashboardStats()
        this.stats = response
      } catch (err) {
        console.error('Failed to fetch attendance stats:', err)
        this.stats = null
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped src="./DashboardAttendanceToday.css"></style>

<style scoped>
.chart-svg-rotated {
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
}

.chart-center-content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
